import { api } from "./client";

export type NotificationSeverity = "info" | "warn" | "error";

export interface Notification {
  id: number;
  severity: NotificationSeverity;
  kind: string;
  title: string;
  body: string | null;
  is_read: boolean;
  created_at: string;
  device_id: string | null;
}

export interface NotificationListResponse {
  notifications: Notification[];
  unread_count: number;
}

export const notificationsApi = {
  list: (limit = 50) =>
    api.get<NotificationListResponse>(
      `/api/dashboard/notifications?limit=${limit}`,
    ),
  markRead: (ids: number[] | null = null) =>
    api.post<{ updated: number }>("/api/dashboard/notifications/read", { ids }),
};
